import React from 'react';
import MarketSelectionHeaders from './MarketSelectionHeaders';
import MarketOddsTable from './MarketOddsTable';

const RightOddsDetailTable = ({ selectedMarkets, oddsDetail }) => (
  <div className="odds__right odds__right--scrollable">
    <table className="odds__table odds__table--dark">
      <thead>
        <tr className="tr--first tr--secondary">
          {selectedMarkets.map(market => {
            if (!market || market.selections === undefined) {
              return null;
            }

            return (
              <th key={market.id}>{market.name}</th>
            );
          })}
        </tr>
        
        <MarketSelectionHeaders selectedMarkets={selectedMarkets} />
      </thead>
      <tbody>
        <MarketOddsTable selectedMarkets={selectedMarkets} oddDetail={oddsDetail} />
      </tbody>
    </table>
  </div>
);

export default RightOddsDetailTable;